<template>
  <label
    class="filters-button"
    :class="{
      'is-selected': isChecked,
      'is-disabled': !filter.count || props.forceDisabled,
    }"
  >
    <input
      type="checkbox"
      class="filters-button__checkbox"
      v-model="isChecked"
    />
    <div class="filters-button__label text-base3">
      <span>{{ $t('filters.' + filter.label) }}</span>
      <!-- <span>{{ filter.label }}</span> -->
    </div>
  </label>
</template>

<script setup>
const emit = defineEmits(['select:filter'])

const props = defineProps({
  filter: Object,
  selected: Boolean,
  forceDisabled: Boolean,
  label: String,
})

const { filter, selected } = toRefs(props)

const isChecked = ref(selected.value)

// Watch for changes in the selected prop and update isChecked accordingly
watch(selected, (newVal) => {
  if (isChecked.value !== newVal) {
    isChecked.value = newVal
  }
})

// Emit event only if the new value is different
watch(isChecked, (newVal) => {
  if (newVal !== selected.value) {
    emit('select:filter', filter.value)
  }
})
</script>

<script>
export default {
  name: 'FiltersButton',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
